'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _itemContainer = require('../item/itemContainer.js');

var _itemContainer2 = _interopRequireDefault(_itemContainer);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

var _windowWrapper = require('@wix/photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupView = function (_React$Component) {
  (0, _inherits3.default)(GroupView, _React$Component);

  function GroupView(props) {
    (0, _classCallCheck3.default)(this, GroupView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GroupView.__proto__ || (0, _getPrototypeOf2.default)(GroupView)).call(this, props));

    _this.displayName = 'GroupView';
    _this.dom = [];
    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(GroupView, [{
    key: 'createDom',
    value: function createDom(visible) {
      var _this2 = this;

      return this.props.items.map(function (item) {
        return _react2.default.createElement(_itemContainer2.default, _lodash2.default.merge(item.renderProps(_lodash2.default.merge(_this2.props.galleryConfig, { visible: visible })), { store: _this2.props.store }));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var groupStyle = {
        width: this.props.width,
        height: this.props.totalHeight
      };
      return _react2.default.createElement(
        'div',
        {
          key: 'group_' + this.props.idx,
          'data-hook': 'group-view'
        },
        this.createDom(true)
      );
    }
  }]);
  return GroupView;
}(_react2.default.Component);

exports.default = GroupView;